import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSend = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 12,
	height: 12,
	viewBox: "0 0 12 12",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		id: "Frame 2087328681",
		children: /* @__PURE__ */ _jsx("path", {
			id: "Vector (Stroke)",
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M9.19118 2.24931C9.42494 2.24931 9.61444 2.43881 9.61444 2.67257L9.61444 7.46118C9.61444 7.69494 9.42494 7.88443 9.19118 7.88443C8.95742 7.88443 8.76792 7.69494 8.76792 7.46118L8.76792 3.6944L3.10566 9.35667C2.94036 9.52196 2.67237 9.52196 2.50708 9.35667C2.34179 9.19138 2.34179 8.92338 2.50708 8.75809L8.16935 3.09583L4.40257 3.09583C4.16881 3.09582 3.97931 2.90633 3.97931 2.67257C3.97931 2.43881 4.16881 2.24931 4.40257 2.24931L9.19118 2.24931Z",
			fill: "white",
			stroke: "white",
			strokeWidth: .75
		})
	})
});
const ForwardRef = forwardRef(SvgSend);
export default ForwardRef;
